module.exports = __webpack_public_path__ + "static/img/fontawesome-webfont.d7c6390.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.svg?v=4.6.3
 ** module id = 568
 ** module chunks = 1
 **/